let categorySplide = new Splide('.pdp-ingradients-wrapper .splide', {
      type       : 'slide',
      perPage    : 4,
      arrows     : true,
      drag       : true,
      gap        : '2rem',
      pagination : false,
      breakpoints: {
        1280: {
          perPage: 3,
        },
        767: {
          perPage: 2,
        },
        480: {
          perPage: 1,
        },
        640: {
          drag: true
        }
      }
});

categorySplide.mount();